import { render, staticRenderFns } from "./ReSendOp.vue?vue&type=template&id=8937836a&"
import script from "./ReSendOp.vue?vue&type=script&lang=js&"
export * from "./ReSendOp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports